<template>
  <router-view :platInfo="platInfo"></router-view>
</template>

<script setup>
import { ref, getCurrentInstance, computed, onBeforeMount, onUnmounted} from "vue";
import { useRoute, useRouter } from "vue-router";
const { proxy } = getCurrentInstance();
const router = useRouter();
// 动态更改favicon
    const changeFavicon = (src) => {
      var link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      link.href = src+'?timestamp='+Date.now();
    };
    const platInfo = ref({})
    //获取门户信息
    const getPortalInfo = () => {
      proxy
        .$request({
          url: "PROTAL_N_INDUSTRYMANGE_FINDDEFAULTBYTYPE",
          data: {
            portalType: "nfstzx"
          },
          method: "post",
        })
        .then((res) => {
          if (res.data.code == "000") {
            let result = res.data.result;
            changeFavicon(proxy.commenUrl + result.browserIcon);
            document.title = result.browserName;
            platInfo.value.tradeImg = res.data.result.tradeImg
            platInfo.value.gzh = res.data.result.gzh
            platInfo.value.tel = res.data.result.tel
            platInfo.value.logo = res.data.result.logo
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

        // 获取个人信息
    const getUserInfo = ()=>{
        proxy.$request({
            url:"W_PERSON_GET",
            data:{
                isLoginType:true
            },
            method: "post",
        }).then((res)=>{
            if(res.data.code=="000"){
            }
        }).catch((err)=>{
            console.log(err)
        })
    }

    const COOKIE_NAME = 'userInfoB2B';
    let lastToken = null;
    let intervalId = null;

    // 获取当前 token 值
    function getToken() {
      const match = document.cookie.match(new RegExp(`(^| )${COOKIE_NAME}=([^;]*)`));
      return match ? decodeURIComponent(match[2]) : null;
    }

    // Token 变化时的回调函数
    function onTokenChange(newToken, oldToken,type) {
      //type 1 监听 2 轮询
      
      // ✅ 在这里编写你的业务逻辑
      // 示例：
      if (newToken) {
        // Token 新增或更新
        if(type==2){
          proxy.setCookie("userInfoB2B", proxy.getSharedCookie("userInfoB2B"));
          proxy.setCookie("membIdB2B", proxy.getSharedCookie("membIdB2B"));
          // 判断是否是safari浏览器
          if(proxy.tool.isSafari()){
            //刷新页面
            window.location.reload()
          }
        }else if(type==1){
          proxy.setSharedCookie("userInfoB2B", proxy.getCookie("userInfoB2B"))
          proxy.setSharedCookie("membIdB2B",  proxy.getCookie("membIdB2B"))
        }else{
          proxy.setCookie("userInfoB2B", proxy.getSharedCookie("userInfoB2B"));
          proxy.setCookie("membIdB2B", proxy.getSharedCookie("membIdB2B"));
        }
        
      } else {
        // Token 被删除
        if(type==2){
          proxy.setCookie("userInfoB2B", '')
          proxy.setCookie("membIdB2B", '')
        }else if(type==1){
          proxy.setSharedCookie("userInfoB2B", '')
          proxy.setSharedCookie("membIdB2B", '')
        }else{
          proxy.setCookie("userInfoB2B", '')
          proxy.setCookie("membIdB2B", '')
        }
        
      }
    }

    onBeforeMount(() => {
      lastToken = getToken();
      if(getToken()){
        onTokenChange(getToken(), '',3)
      }
      // 1️⃣ 监听 localStorage 事件（实时性高）
      window.addEventListener('storage', (e) => {
        if (e.key === `cookie_sync_${COOKIE_NAME}`) {
          const data = JSON.parse(e.newValue);
          if (data.value !== lastToken&&!data.value) {
            onTokenChange(data.value, lastToken,1);
            lastToken = data.value;
          }
        }
      });

      // 2️⃣ 轮询作为保底方案（3秒检查一次）
      intervalId = setInterval(() => {
        const current = getToken();
        if (current !== lastToken) {
          onTokenChange(current, lastToken,2);
          lastToken = current;
        }
      }, 1000);
      getPortalInfo()
      getUserInfo()
    });

    onUnmounted(() => {
      clearInterval(intervalId);
    });
</script>

<style>
#app {
  width: 100%;
  height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f7f7f7;
  color: #666666;
}
</style>
